var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.22262 7.74598L5.19088 5.71355L8.73352 2.17021L10.1718 0.733337L10.1876 0.717464C10.276 0.627681 10.3902 0.582397 10.498 0.582397C10.5863 0.582397 10.6718 0.614009 10.7352 0.677231L10.7911 0.733202L12.2604 2.20113C12.3279 2.26862 12.3617 2.36345 12.3531 2.46621C12.3458 2.57034 12.2977 2.67161 12.2194 2.7492L7.22262 7.74598ZM10.9326 5.61147V9.9221C10.9326 10.318 10.6115 10.6405 10.2142 10.6405H3.02982C2.63394 10.6405 2.31139 10.318 2.31139 9.9221V2.01928H7.34045L8.77732 0.58241H2.31139C1.51823 0.58241 0.874512 1.22613 0.874512 2.01928V9.9221C0.874512 11.1125 1.84009 12.0774 3.02982 12.0774H10.2142C11.4053 12.0774 12.3695 11.1125 12.3695 9.9221V4.1746L10.9326 5.61147ZM3.90272 9.03345L6.77647 8.31502L5.69882 7.23736L4.62116 6.1597L3.90272 9.03345Z",
    fill: "#A9A9BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.9f9456bbcd8f7f82c8d5ce1b4e6bfe29.svg";
export { ForwardRef as ReactComponent };